import { createStyles } from "@mui/styles";

const parallaxStyle = createStyles({
  parallax: {
    display: "flex",
    minHeight: "45vh",
    overflow: "hidden",
    position: "relative",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    margin: "0",
    padding: "0",
    border: "0",
    "@media (max-height: 500px)": {
      minHeight: "75vh",
    },
  },
  filter: {
    "&:before": {
      background: "rgba(0, 0, 0, 0.5)",
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: 0,
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''",
    },
  },
});

export default parallaxStyle;
